export var ELoaderThemes;
(function (ELoaderThemes) {
    ELoaderThemes["PRIMARY"] = "PRIMARY";
    ELoaderThemes["SECONDARY"] = "SECONDARY";
    ELoaderThemes["TERTIARY"] = "TERTIARY";
})(ELoaderThemes || (ELoaderThemes = {}));
export var EMessagePosition;
(function (EMessagePosition) {
    EMessagePosition["TOP"] = "TOP";
    EMessagePosition["BOTTOM"] = "BOTTOM";
    EMessagePosition["LEFT"] = "LEFT";
    EMessagePosition["RIGHT"] = "RIGHT";
})(EMessagePosition || (EMessagePosition = {}));
